import { updateNotifications } from '../redux/reducers/adminNotificationMessages/adminNotificationMessages';
import { store } from '../redux/store'; 


const setupSocketListeners = (socket) => {
    const { dispatch } = store

    socket.on('connect', () => {
        console.log('Connected to server')
    })

    socket.on('alertEmgNotification', (data) => {
        const currentState = store.getState()

        dispatch(updateNotifications([data, ...currentState.emergencyMessages.notifications]))
    })

    socket.on('dismissEmgNotification', (data) => {
        console.log("entered dismissEmgNotification", data)
        const currentState = store.getState()

        let updatedNotifications = JSON.parse(JSON.stringify(currentState.emergencyMessages.notifications))
        updatedNotifications = [...updatedNotifications]
        updatedNotifications = updatedNotifications.map(eachNotification => {
            if(eachNotification.notificationId === data.notificationId){
                eachNotification.statusId = data.statusId
            }
            return eachNotification
        })
        updatedNotifications = updatedNotifications.filter(eachNotification => eachNotification.statusId !== 19)
        dispatch(updateNotifications(updatedNotifications))
    })

    socket.on('disconnect', () => {
        console.log('Disconnected from server')
    })

    socket.on('error', (error) => {
        console.log('Socket error:', error)
    })
}

export default setupSocketListeners;